<template>
  <RouterView/>
  <!-- <CheckoutIndividual/> -->
  <!-- <LandingPageHome/> -->
</template>

<script>
// import LandingPageHome from './views/LandingPageHome.vue'
// import CheckoutIndividual from './views/CheckoutIndividual.vue';

export default {
  name: 'App',
  components: {
    // LandingPageHome,
    //  CheckoutIndividual
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
